
      export const versions = {
        commit: 'cf553e1e7748cdfa993c852aa54368141a25cfbe',
        branch: 'HEAD'
      };
